export const partnerDividendsInitValue = {
  data: {
    dividends: [],
    totalDividendsAmount: 0,
    dividendsTemplateDocument: null,
    showTitle: true,
    isSummaryView: false,
    isLoading: false,
  },
};
